// extracted by mini-css-extract-plugin
module.exports = {"background":"Empresa_background__3selF","main":"Empresa_main__2d-I3","text":"Empresa_text__28zoM"};